import { FC } from "react";

export const EmptyPage: FC = () => {
  return <div style={{ position: "absolute", top: '45%', width: '99%', textAlign: 'center' }}> Continue by selecting item from left tree...</div >;
}